import React, { Fragment } from "react";
import { Link, withRouter } from "react-router-dom";
import Table from "react-bootstrap/Table";
import ToggleButtonGroup from "react-bootstrap/ToggleButtonGroup";
import ToggleButton from "react-bootstrap/ToggleButton";
import Button from "react-bootstrap/Button";
import ButtonToolbar from "react-bootstrap/ButtonToolbar";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import moment from "moment";
import axios from "axios";
import { API_ROOT, API_HOST, API_ROOT1 } from "../utils/api-config";

class DeliveryInstructions extends React.Component {
  componentDidMount() {
    this.props;
  }

  render() {
    const { deliveries } = this.props;

    return (
      <div className="container-fluid">
        <Table striped bordered hover responsive>
          <thead>
            <tr className="table-primary">
              <th>Timeslot</th>
              <th>Order</th>
              <th>Instructions</th>
              <th>Neighborhood</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {deliveries.map((item, i) => {
              const renderElement = () => {
                if (deliveries[i].cancelled)
                  return (
                    <span className="badge badge-pill  badge-danger">
                      Cancelled
                    </span>
                  );
                else if (
                  deliveries[i].failed_at.length > 0 &&
                  !deliveries[i].route_id &&
                  !deliveries[i].delivered &&
                  moment(
                    deliveries[i].failed_at[deliveries[i].failed_at.length - 1]
                  ).format("YYYY-MM-DD") === deliveries[i].date &&
                  !deliveries[i].started
                )
                  return (
                    <span className="badge badge-pill  badge-danger">
                      Failed
                    </span>
                  );
                else if (
                  !deliveries[i].pick_up_time &&
                  !deliveries[i].entered_dc_at &&
                  !deliveries[i].delivered
                )
                  return (
                    <span className="badge badge-pill  badge-warning">
                      {deliveries[i].pick_up ? "With customer" : "In store"}
                    </span>
                  );
                else if (
                  deliveries[i].entered_dc_at &&
                  !deliveries[i].pick_up_time &&
                  !deliveries[i].delivered
                )
                  return (
                    <span className="badge badge-pill  badge-success">
                      In DC
                    </span>
                  );
                else if (deliveries[i].pick_up_time && !deliveries[i].delivered)
                  return (
                    <span className="badge badge-pill  badge-info">
                      Picked Up
                    </span>
                  );
                else if (deliveries[i].delivered)
                  return (
                    <span className="badge badge-pill  badge-success">
                      Delivered
                    </span>
                  );
                else if (
                  !deliveries[i].entered_dc_at &&
                  !deliveries[i].pick_up_time &&
                  deliveries[i].route_id
                )
                  return (
                    <span className="badge badge-pill  badge-secondary">
                      Routed
                    </span>
                  );

                return null;
              };
              return (
                <tr key={deliveries[i].id} className="table-colum">
                  <td>{deliveries[i].delivery_window || ""} </td>
                  <td className={"badge-link"}>
                    <Link to={`/fulfillments/${deliveries[i].order_id}`}>
                      {deliveries[i].name} - {deliveries[i].order_number}
                    </Link>{" "}
                    <span>
                      {deliveries[i].shipto_first_name}{" "}
                      {deliveries[i].shipto_last_name}
                    </span>
                  </td>
                  <td>{deliveries[i].delivery_instructions || ""} </td>
                  <td>{deliveries[i].neighborhood || ""}</td>
                  <td>
                    {deliveries[i].started &&
                    !deliveries[i].pick_up &&
                    deliveries[i].route_id ? (
                      <a
                        href={`${API_HOST}/loc?t=${deliveries[i].task}&r=${deliveries[i].shopify_order_id}`}
                        target="_blank"
                      >
                        {deliveries[i].delivered ? (
                          <span className="badge badge-pill  badge-success">
                            Delivered
                          </span>
                        ) : (
                          <span className="badge badge-pill  badge-secondary">
                            Started
                          </span>
                        )}
                      </a>
                    ) : (
                      renderElement()
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    );
  }
}

export default withRouter(DeliveryInstructions);
